<template>
  <v-container v-if="isAuth" fluid fill-height>
    <v-row class="justify-center">
      <v-col cols="12" md="8" sm="6">
        <password-form-invira :me="me" @success="redirectToHome" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PasswordFormInvira from './PasswordFormInvira.vue'

export default {
  name: 'PasswordPageInvira',
  components: { PasswordFormInvira },
  computed: {
    ...mapGetters(['isAuth', 'me'])
  },
  methods: {
    redirectToHome() {
      this.$router.push({ name: 'home' }).catch(() => {})
    }
  }
}
</script>
